export const White = '#FFFFFF';
export const Black = '#000000';
export const Red = '#E9103A';
